module.exports = __webpack_public_path__ + "img/checkIcon@2x.1ef6aca7.png";